














































import { Component, Mixins } from "vue-property-decorator";
import { ProjectTeam } from "../../../domain/projectTeam";
import { ISingleSelectableAsynchronously } from "../../system/selectors";
import ProjectTeamListSelector from "../selectors/ProjectTeamListSelector.vue";
import { ProjectTeamSelectableDialogMixin } from "./mixins";

@Component({
  components: {
    ProjectTeamListSelector,
  },
})
export default class ProjectTeamListSelectorDialog extends Mixins(ProjectTeamSelectableDialogMixin) implements ISingleSelectableAsynchronously<ProjectTeam> {
  async selectOption(defaultOption?: ProjectTeam): Promise<ProjectTeam> {
    return this.show<ProjectTeam>(defaultOption);
  }
}
